import { render, staticRenderFns } from "./FormGroupTextarea.vue?vue&type=template&id=5d628bbc&"
import script from "./FormGroupTextarea.vue?vue&type=script&lang=js&"
export * from "./FormGroupTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports